import Api from '@/api/api.js'

export default {
    getAnalyse(id) {
        const promise = Api().get('/analyses/' + id)

        return promise.then((response) => response.data)
    },
    getMinimalAnalyses(){
        const promise = Api().get('/analyses/minimalist')
        return promise.then((response) => response.data)
    },

    getAnalyses() {
        const promise = Api().get('/analyses')
        return promise.then((response) => response.data)
    },

    //Save analyse
    saveAnalyse(data) {
        const promise = Api().post('/analyses/save', data)
        return promise.then((response) => response.data)
    },

    //Edit Analyse
    editAnalyse(id, data) {
        const promise = Api().put('/analyses/edit/' + id, data)
        return promise.then((response) => response.data)
    },

    //Supprimer Analyse
    deleteAnalyse(id) {
        const promise = Api().delete('/analyses/delete/' + id)
        return promise.then((response) => response.data)
    },

    saveCategorieAnalyse(data) {
        const promise = Api().post('/categories_analyses/save', data)
        return promise.then((response) => response.data)
    },
    getCategoriesAnalyses() {
        const promise = Api().get('/categories_analyses')
        return promise.then((response) => response.data)
    },
    getAllCategoriesAnalyses() {
        const promise = Api().get('/categories_analyses?with_empty=true')
        return promise.then((response) => response.data)
    },


    //Save bon d'analyse
    saveBonAnalyse(id, data) {
        const promise = Api().post('/bulletins-analyses/' + id + '/save-bon', data)
        return promise.then((response) => response.data)
    },

    saveOrdonnance(data) {
        const promise = Api().post('/ordonnances/save', data)
        return promise.then((response) => response.data)
    },

    deleteOrdonnance(id) {
        const promise = Api().delete('/ordonnances/delete/' + id)
        return promise.then((response) => response.data)
    },

    editPrescription(id, data) {
        const promise = Api().put('/prescriptons/edit/' + id, data)
        return promise.then((response) => response.data)
    },

    deletePrescription(id) {
        const promise = Api().delete('/prescriptons/delete/' + id)
        return promise.then((response) => response.data)
    },

    saveDossierMedical(data) {
        const promise = Api().post('/dossiers_medicaux/save', data)
        return promise.then((response) => response.data)
    },

    saveTypeExamenClinique(data) {
        const promise = Api().post('/dossiers_medicaux/save', data)
        return promise.then((response) => response.data)
    },

    getTypeExamenClinique(id) {
        const promise = Api().get('/dossiers_medicaux/' + id)
        return promise.then((response) => response.data)
    },

    saveExamenClinique(data) {
        const promise = Api().post('/examens-cliniques/save', data)
        return promise.then((response) => response.data)
    },

    getDemandesTraites() {
        const promise = Api().get('/demandes-analyses/traites')
        return promise.then((response) => response.data)

    },

    getDemandesParametresResult(analyse) {
        const promise = Api().get('/demandes-analyses/' + analyse)
        return promise.then((response) => response.data)
    },

    saveDemandesResult(data) {
        const promise = Api().post('/demandes-analyses/resultat/save', data)
        return promise.then((response) => response.data)
    },

    importResultatAnalyse(id,data){
        const promise = Api().post('/demandes-analyses/'+id+'/upload_resultat', data)
        return promise.then((response) => response.data)
    },

    updateResultatCommentaires(id,data){
        const promise = Api().post('/demandes-analyses/'+id+'/update_commentaires', data)
        return promise.then((response) => response.data)
    },

    getPlasmodiums() {
        const promise = Api().get('/plasmodiums')
        return promise.then((response) => response.data)
    },

    getStadesPlasmodiums() {
        const promise = Api().get('/stades-plasmodiums')
        return promise.then((response) => response.data)
    },

    getDemandeResultat(id) {
        const promise = Api().get('/demandes-analyses/' + id + '/resultat')
        return promise.then((response) => response.data)
    },

    getPrescripteur(id) {
        const promise = Api().get('/users/' + id)
        return promise.then((response) => response.data)

    },

    updateTDR(id, data) {
        const promise = Api().put('/demandes-analyses/' + id + '/update_tdr', data)
        return promise.then((response) => response.data)
    },

    getAnalysesByTypeConsultation(type) {
        const promise = Api().get('/get-analyses/type_cons/' + type)
        return promise.then((response) => response.data)
    },
    
    searchAnalyse(keyword){
        const promise = Api().get('/analyse/resort?search_word='+keyword)
        return promise.then((response) =>response.data)
    },

    saveAnalyseResult(data) {
        const promise = Api().post('/analyses/store/resultat', data)
        return promise.then((response) => response.data)
    },

    getAnalysesEnSalleAttente(data) {
        const promise = Api().post('/consultations/analyse-en-salle', data)
        return promise.then((response) => response.data)
    },

    getListePatientAnalyseToFill(data) {
        const promise = Api().post('/consultations/analyse/remplir', data)
        return promise.then((response) => response.data)
    },

    getRegistreAnalyse(data) {
        const promise = Api().post('/consultations/analyse/registre', data)
        return promise.then((response) => response.data)
    },

    getBulletinAnalyses(data) {
        const promise = Api().post('/analyses/liste/bulletin-analyses', data)
        return promise.then((response) => response.data)
    },

    editRenseignementClinique(data) {
        const promise = Api().post('/bulletins/edit/renseignement-clinique', data)
        return promise.then((response) => response.data)
    },

    saveBulletinAnalyse(data) {
        const promise = Api().post('/bulletins/save/analyses', data)
        return promise.then((response) => response.data)
    },

    deleteBulletinAnalyse(data) {
        const promise = Api().post('/bulletins/analyses/delete', data)
        return promise.then((response) => response.data)
    },

    getDistinctAnalyse() {
        const promise = Api().get('/analyses/distinct/get-analyses')
        return promise.then((response) => response.data)
    },

    getListeAnalyseByCategory() {
        const promise = Api().get('/categories_analyses/liste/analyse')
        return promise.then((response) => response.data)
    },

    saveResultatTDR(data) {
        const promise = Api().post('/analyses/tdr/store', data)
        return promise.then((response) => response.data)
    },

    getBulletinAnalysesPatient(data) {
        const promise = Api().post('/demandes-analyses/registre/bulletin-patient', data)
        return promise.then((response) => response.data)
    },

    getListePatientAttentePrelevement(data) {
        const promise = Api().post('/bulletin-analyse/attente-prelevement', data)
        return promise.then((response) => response.data)
    },

    savePrelevementsEffectues(data) {
        const promise = Api().post('/bulletin-analyse/save-prelevement', data)
        return promise.then((response) => response.data)
    },

    getResultatAnalysePatient(data) {
        const promise = Api().get('/analyses/'+data.analyseId+'/bulletins/'+data.bulletinId+'/resultats')
        return promise.then((response) => response.data)
    },

    shareResultatAnalyse(demande_analyse_id) {
        const promise = Api().post('/cca-mobile/analyses-bio-results/'+demande_analyse_id+'/share')
        return promise.then((response) => response.data)
    },
}